<template>
  <div class="production_wrap">
    <div class="production_img">
      <div class="img_desc"></div>
    </div>
    <div class="area_info">
      <div class="production_inner">
        <div class="inner_center">
          <img src="../../assets/icon_jigou.png" alt="" srcset="">
          <div class="production_title">我们的机构</div>
        </div>
        <div class="inner_right">
          <img src="../../assets/icon_jigou_line.png" alt="" />
        </div>
      </div>
    </div>
    <div class="org_select">
      <div class="org_select_item" :class="{ 'active': activeIndex == 0 }"  @mouseover="changeOptionIndex(0)" >新都街道为老服务中心</div>
      <div class="org_select_item" :class="{ 'active': activeIndex == 1 }"  @mouseover="changeOptionIndex(1)">师古敬老院</div>
    </div>

    <div class="org_card" v-if="activeIndex == 0">
      <div class="lft_img">
        <img src="../../assets/xdzht.jpg" alt="" srcset="">
      </div>
      <div class="rht_content">
        <div class="rht_title">
          <img style="margin-right: 1rem;" src="../../assets/org_icon.png" alt="" srcset="">
          <span>新都街道为老服务中心</span>
          </div>
        <div class="rht_text">为社区内生活的高龄老人、空巢老人以及失能、半失能长者提供膳食供应、生活照料、休闲娱乐等日间托养服务。</div>
        <button class="btn">立即咨询</button>
      </div>
    </div>

    <div class="org_card" v-if="activeIndex == 1">
      <div class="lft_img">
        <img src="../../assets/xgNursingHome.jpg" alt="" srcset="">
      </div>
      <div class="rht_content">
        <div class="rht_title">
          <img style="margin-right: 1rem;" src="../../assets/org_icon.png" alt="" srcset="">
          <span>师古敬老院</span>
          </div>
        <div class="rht_text">为社区内生活的高龄老人、空巢老人以及失能、半失能长者提供膳食供应、生活照料、休闲娱乐等日间托养服务。</div>
        <button class="btn">立即咨询</button>
      </div>
    </div>    

    <div class="area_info_btn">
      <div class="area_btns">
        <button class="area-btn" :class="{'active_area_btn': areaIndex == 0}" @click="areaIndex=0" >成都</button>
        <button class="area-btn" :class="{'active_area_btn': areaIndex == 1}" @click="areaIndex=1" >德阳</button>
        <button class="area-btn" :class="{'active_area_btn': areaIndex == 2}" @click="areaIndex=2" >遂宁</button>
        <button class="area-btn" :class="{'active_area_btn': areaIndex == 3}" @click="areaIndex=3" >宜宾</button>
      </div>
    </div>

    <div class="area_title">
      <span>{{ areaList[areaIndex].name }}</span>/<span>{{ areaList[areaIndex].en }}</span>
    </div>
    <NursingCard title="新都街道综合为老服务中心" description="新都街道综合为老服务中心" imageUrl="xdzht" roomTypes="单人间" beds="20张" address="成都市新都区" ></NursingCard>  

    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import NursingCard from './NursingCard.vue'

export default {
  data() {
    return {
      procardList: [
        {
          tit: '产业链数据中心',
        },
        {
          tit: '产业链监测',
        },
        {
          tit: '产业评价',
        },
        {
          tit: '产业地图',
        },
        {
          tit: '智能招商系统及服务',
        },
      ],
      procardList2: [
        {
          tit: '智达康选址',
        },
        {
          tit: '产业链监测',
        },
      ],
      activeIndex: 0,
      areaIndex: 0,
      areaList: [
        {
          name: '成都',
          en: 'chengdu',
        },
        {
          name: '德阳',
          en: 'deyang',
        },
        {
          name: '遂宁',
          en: 'suining',
        },
        {
          name: '宜宾',
          en: 'yibin',
        }
      ]
    }
  },

  methods: {
    changeOptionIndex(index) {
      this.activeIndex = index
    },
  },

  components: {
    CallMe,
    MobileCallme,
    NursingCard
  },
}
</script>

<style lang="scss" scoped>
.production_wrap {
  width: 100%;
  background-color: #fefbf8;

  .production_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url('../../assets/img/cover.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .area_info_btn {
    width: 80vw;
    margin: 4.6rem auto 0rem;

    .area_btns {
      display: flex;
      margin-bottom: 1.6rem;
      gap: 0 0.8rem;
    }

    .area-btn {
      border-radius: 0.5rem;
      font-size: 1.4rem;
      border: none;
      width: 6.2rem;
      line-height: 3.2rem;
      color: #000;
      border: solid 0.01rem transparent;
      background-color: transparent;
    }

    .active_area_btn {
      border: solid 0.01rem #ff7000;
      color: #ff7000;
    }
  }

  .area_info {
    width: 100%;
    margin-top: 50px;

    .production_inner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .inner_center {
        display: flex;
        font-size: 2.5rem;
        color: #ff7000;
        font-weight: bold;
        align-items: center;
        margin-bottom: 2rem;

        img {
          margin-right: 1rem;
        }
      }
    }
  }
  .org_select {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 100px;
    @media screen and (max-width: 768px) {
      justify-content: space-around;
      flex-wrap: wrap;
    }
    
    .org_select_item { 
      color: #444;
      font-size: 1.4rem;
      padding: 0 1.5rem;
      border-radius: 0.3rem;
      height: 3.5rem;
      line-height: 3.5rem;
      margin: 0 1rem;
      border: solid 0.1rem transparent;
    }

    .active { 
      color: #ff7000;
      border: solid 0.1rem #ff7000;
    }
  }

  .org_card {
    width: 80vw;
    height: 36vh;
    border-radius: 10px;
    box-shadow: -1px -1px 10px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    margin: 0 auto;
    overflow: hidden;

    .lft_img {
      flex: 1;

      img {
        height: 100%;
        width: 100%;
        transition: all 0.5s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }

    .rht_content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0 5rem;
      justify-content: space-around;
      align-items: center;
      
      
      .rht_title {
        margin-top: 4rem;
        width: 100%;
        height: 20%;
        font-size: 1.8rem;
        color: #444444;
        padding-bottom: 0.8rem;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ff7000;
        justify-content: center;

        span {
          line-height: 100%;
        }
      }

      .rht_text {
        margin: 2rem 0 2.5rem;
        color: #666666;
        font-size: 1.2rem;
      }

      .btn {
        border-radius: 0.5rem;
        font-size: 1.4rem;
        border: none;
        width: 12.2rem;
        line-height: 3.2rem;
        background-color: #ff7000;
        border: solid 0.01rem #ff7000;
        color: white;
      }
    }
  }


  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }
  .production_card {
    display: flex;
    justify-content: center;
  }

  .area_title {
    width: 80vw;
    text-align: center;
    border-bottom: 1px solid #bfbfbf;
    font-size: 2.2rem;
    padding-bottom: 1.6rem;
    margin: 2rem auto 2rem;
    position: relative;

    &:after { 
      content: '';
      display: block;
      width: 6vw;
      height: 0.5rem;
      background-color: #ff7000;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -0.5rem;
    }
  }

  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .product_shows_wrap {
    width: 100%;
    background: url('../../assets/img/witness-bgc369221.png') 0 0 no-repeat;
    background-size: cover;
    padding: 10px 0 50px 0;
    margin-top: 100px;
    box-sizing: border-box;
    .with_center {
      display: flex;
      justify-content: center;
      .bottom_img_wrap {
        width: 80%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        @media screen and (max-width: 768px) {
          width: 100%;
        }
        .bottom_img_item {
          width: 30%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 20px;
          margin: 20px;
          h2 {
            color: #3b3b3b;
          }
          @media screen and (max-width: 768px) {
            width: 45%;
          }
          .bottom_img {
            width: 100%;
            position: relative;
            img {
              width: 100%;
            }

            .img_desc {
              position: absolute;
              bottom: 20px;
              width: 100%;
              text-align: center;
              color: #fff;
              font-size: 18px;
              @media screen and (max-width: 768px) {
                font-weight: bold;
                bottom: 8px;
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
}
</style>